module.exports = __webpack_public_path__ + "img/times-circle-regular.3b2678c0.svg";